<script>
import VideoBackground from '@/components/_common/special/VideoBackground.vue'
import BaseModal from '@/components/_common/modal/BaseModal.vue'
import SupportBlocks from '@/components/HomePage/SupportBlocks.vue'
export default {
  name: 'RealWorldCaseloads',
  components: {
    VideoBackground,
    BaseModal,
    SupportBlocks
  },
  data () {
    return {
      showRequirementsModal: false
    }
  },
  computed: {
    vidDimensions () {
      let dims = {
        width: '42rem',
        height: '25rem'
      }
      switch (this.$mq) {
        case 'mobile':
          dims = {
            width: 'calc(100vw - 2rem)',
            height: 'auto'
          }
          break
        case 'tablet':
          dims = {
            width: 'calc(50vw - 2rem)',
            height: 'auto'
          }
          break
        case 'desktop':
          dims = {
            width: '31.5rem',
            height: '18.75rem'
          }
          break
        case 'widescreen':
          dims = {
            width: '42rem',
            height: '25rem'
          }
          break
      }
      return dims
    }
  }
}
</script>

<template>
  <section class="customizable-section">
    <div>
      <div id="section-title-tablet" class="mb-5">
        <h2 class="h2-promo mb-4 has-text-white text-outline-dark">Built for Real-World Caseloads</h2>
        <h3 class="h3-promo mb-4 has-text-white">OVB supports mixed diagnoses and patient populations within one consistent therapy platform</h3>
      </div>
      <div class="flexi-grid">
        <section id="grid-video">
          <div class="video-overlay">
            <video
              :src="require('@/assets/promo/video/CustomizableTools/games.webm')"
              :poster="require('@/assets/promo/img/home/CustomizableTools/games_poster.webp')"
              aspect-ratio="16/9"
              height="100%"
              width="100%"
              autoplay
              playsinline
              disablepictureinpicture
              loop
              preload="auto"
              muted
              :controls="false"
              :autoplay="true"
            />
            <div class="overlay" />
          </div>
<!--          <video-background-->
<!--              :video-source="require('@/assets/promo/video/CustomizableTools/games.webm')"-->
<!--              :poster-image="require('@/assets/promo/img/home/CustomizableTools/games_poster.webp')"-->
<!--              aspect-ratio="16/9"-->
<!--              :height="vidDimensions.height"-->
<!--              :width="vidDimensions.width"-->
<!--              class="game-video"-->
<!--          />-->
        </section>
        <section id="grid-content-desktop">
          <header>
            <h2 class="h2-promo mb-4 has-text-white text-outline-dark">Built for Real-World Caseloads</h2>
            <h3 class="h3-promo mb-4 has-text-white">OVB supports mixed diagnoses and patient populations within one consistent therapy platform</h3>
          </header>
          <div>
            <ul class="list-discs points-of-interest article-body text-semibold has-text-white">
              <li class="poi">Binocular vision therapy including amblyopia and strabismus</li>
              <li class="poi">Neuro-rehabilitation including concussion care</li>
              <li class="poi">Neurodivergent profiles</li>
              <li class="poi">Reading and academic challenges</li>
              <li class="poi">Sports vision applications</li>
              <li class="poi">Pediatric through adult patients</li>
            </ul>
          </div>
        </section>
        <section>
          <header id="section-title-mobile">
            <h2 class="h2-promo mb-4 has-text-white text-outline-dark">Built for Real-World Caseloads</h2>
            <h3 class="h3-promo mb-4 has-text-white">OVB supports mixed diagnoses and patient populations within one consistent therapy platform</h3>
          </header>
        </section>
        <div id="section-content-mobile">
          <ul class="list-discs points-of-interest article-body text-semibold">
            <li class="poi">Binocular vision therapy including amblyopia and strabismus</li>
            <li class="poi">Neuro-rehabilitation including concussion care</li>
            <li class="poi">Neurodivergent profiles</li>
            <li class="poi">Reading and academic challenges</li>
            <li class="poi">Sports vision applications</li>
            <li class="poi">Pediatric through adult patients</li>
          </ul>
        </div>
      </div>
      <support-blocks class="support-blocks mt-6"/>
    </div>
  </section>
</template>

<style scoped lang="scss">
.customizable-section {
  display: flex;
  align-items: center;
  margin: 4rem 0;
  @include tablet {

  }
  @include desktop {
    margin: 0 0 20rem 0;
  }
}
.flexi-grid {
  display: grid;
  grid-template-areas:
    "title-mobile"
    "vid"
    "content-mobile";
  grid-template-columns: 1fr;
  grid-column-gap: 2rem;
  grid-row-gap: 1rem;
  @include tablet {
    grid-template-areas:
    "content-mobile vid";
    grid-template-columns: 1fr 1fr;
  }
  @include desktop {
    grid-template-areas:
    "content-dekstop vid";
    grid-template-columns: 1fr 1fr;
  }
}
#grid-video {
  grid-area: vid;
}
#grid-content-desktop {
  grid-area: content-dekstop;
  display: none;
  @include desktop {
    display: block;
  }
}
#section-title-mobile {
  grid-area: title-mobile;
  display: block;
  @include tablet {
    display: none;
  }
  @include desktop {
    display: none;
  }
}

#section-title-tablet {
  display: none;
  @include tablet {
    display: block;
  }
  @include desktop {
    display: none;
  }
}

#section-content-mobile{
  grid-area: content-mobile;
  display: block;
  @include desktop {
    display: none;
  }
}
  .game-video {
    border-radius: 0.375rem;
    display: inline-block;
    overflow: hidden;
    filter: drop-shadow(10px 0px 100rem #21566e);
    //box-shadow: 0 0.5em 1em -0.125em rgba(10.2, 10.2, 10.2, 0.1), 0 0px 0 1px rgba(10.2, 10.2, 10.2, 0.02);
  }
  .list-title {
    font-size: $size-3;
    line-height: $size-3;
    color: $feldgrau;
    font-weight: $font-semibold;;
  }
  .points-of-interest {
    li {
      color: $white;

      @include tablet {
        font-size: $size-5;
      }
    }
  }
.vid-overlay {
  display:grid;
  .overlay {
    width: 100%;
    height: 100%;
    background-color: transparent;
    grid-area: 1/1;
    z-index: 10;
  }
  .video-player {
    border-radius: 0.325rem;
    filter: drop-shadow(0px 0px 80px rgba(0, 0, 0, 0.5));
    grid-area: 1/1;
  }

}
</style>
